import { ScreenId } from '@/types/screenId';

// NOTE：ブラウザのURLで露出しないための考慮
// Base64化する際にidだけだと文字列が短いので、id以外の特に露出しても問題ない値を加えている
// これらのIDは見られても特に問題はない（バックエンドで随時チェックしている。サポート関係など）
interface UserIdPathParam {
  accountName: string;
  userId: number;
}

interface FootballlogIdPathParam {
  date: string;
  footballlogId: number;
  // FIXME: fromScreenIdを削除しpreviousPathでシンプルに実装したい
  fromScreenId?: ScreenId;
  previousPath?: string;
}

interface VideoIdPathParam {
  videoId: number;
  divisionId: number;
}

/**
 * ユーザー情報エンコード、デコード(ラッパー)
 * @param input
 * @returns
 */
// エンコード
export function encodeUserId(userid: UserIdPathParam): string {
  return encodeParameter<UserIdPathParam>(userid);
}
// デコード
export function decodeUserId(parameter: string): UserIdPathParam {
  return decodeParameter<UserIdPathParam>(parameter);
}

/**
 * footballlog情報エンコード、デコード(ラッパー)
 * @param input
 * @returns
 */
// エンコード
export function encodeFootballlogId(footballlogid: FootballlogIdPathParam): string {
  return encodeParameter<FootballlogIdPathParam>(footballlogid);
}
// デコード
export function decodeFootballlogId(parameter: string): FootballlogIdPathParam {
  return decodeParameter<FootballlogIdPathParam>(parameter);
}

/**
 * video情報エンコード、デコード(ラッパー)
 * @param input
 * @returns
 */
// エンコード
export function encodeVideoId(videoid: VideoIdPathParam): string {
  return encodeParameter<VideoIdPathParam>(videoid);
}
// デコード
export function decodeVideoId(parameter: string): VideoIdPathParam {
  return decodeParameter<VideoIdPathParam>(parameter);
}

/**
 * オブジェクトエンコード
 * @param input
 * @returns
 */
export function encodeParameter<T>(arg: T): string {
  // オブジェクトをJSON文字列に変換
  const jsonString = JSON.stringify(arg);
  // Base64エンコードおよびURLセーフな形式に変換
  const urlSafeBase64 = base64UrlEncode(jsonString);
  return urlSafeBase64;
}

/**
 * オブジェクトデコード
 * @param input
 * @returns
 */
export function decodeParameter<T>(userid: string): T {
  // // Base64エンコードされたURLセーフな文字列
  // const urlSafeBase64 = 'eyJ1c2VybmFtZSI6InRhcm8iLCJ1c2VySWQiOjEwfQ=='
  // Base64デコードおよび元の形式に変換
  const decodedString = base64UrlDecode(userid);
  // JSON文字列をオブジェクトにパース
  const obj = JSON.parse(decodedString) as T;
  return obj;
}

/**
 * URLエンコード
 * @param input
 * @returns
 */
export function base64UrlEncode(input: string): string {
  const base64Encoded = btoa(input);
  const urlSafeEncoded = base64Encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return urlSafeEncoded;
}

/**
 * URLデコード
 * @param input
 * @returns
 */
export function base64UrlDecode(input: string): string {
  // URLセーフな形式を元のBase64形式に変換
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/');

  // Base64デコード
  const decoded = atob(base64);

  return decoded;
}
